<template>
<div>
    <!-- table -->
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2">
                <label for="trademark-name-input">{{ $t('trademarkOppositionBasisForOpposition.name') }}</label>
                <b-form-input size="sm" v-model="trademarkName" :placeholder="$t('trademarkOppositionBasisForOpposition.name')" @change="getTrademarkOppositionBasisForOppositionList()" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-md-10 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-center">
                    <b-button class="d-inline-block" size="sm" variant="outline-primary" v-on:keyup.enter="getTrademarkOppositionBasisForOppositionList()" @click="getTrademarkOppositionBasisForOppositionList()">{{ $t('others.list') }}</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <vue-good-table class="mt-1" id="trademarkOppositionBasisForOppositionFormTable" ref="trademarkOppositionBasisForOppositionFormTable" :columns="columns" :rows="rows" :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }" styleClass="vgt-table condensed tableSize" :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'logo'" class="text-nowrap">
                {{ $t('trademarkOppositionBasisForOpposition.logo') }}
            </span>
            <span v-else-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('trademarkOppositionBasisForOpposition.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'applicationNo'" class="text-nowrap">
                {{ $t('trademarkOppositionBasisForOpposition.application_no') }}
            </span>
            <span v-else-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('trademarkOppositionBasisForOpposition.trademark') }}
            </span>
            <span v-else-if="props.column.field === 'niceClass'" class="text-nowrap">
                {{ $t('trademarkOppositionBasisForOpposition.trademark_nice_class') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'logo'" class="text-nowrap">
                <b-row>
                    <b-col v-if="props.row.logo" class="font-size: x-small">
                        <a :href="props.row.logo" target="_blank">
                            <img :src="props.row.logo" :alt="$t('trademarkOppositionBasisForOpposition.logo')" style="max-height:40px; width:auto;" />
                        </a>
                    </b-col>
                </b-row>
            </span>
            <span v-else-if="props.column.field === 'select'">
                <b-form-checkbox @change.native="saveTrademarkOppositionBasis($event.target.checked, props.row)" />
            </span>
            <!-- Column: Process -->
        </template>
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getTrademarkOppositionBasisForOppositionList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        trademarkOppositionId: Number,
        getTrademarkOppositionList: {
            type: Function
        },
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('trademarkOppositionBasisForOpposition.select'),
                    field: `select`,
                },
                {
                    label: this.$t('trademarkOppositionBasisForOpposition.logo'),
                    field: `logo`,
                },
                {
                    label: this.$t('trademarkOppositionBasisForOpposition.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('trademarkOppositionBasisForOpposition.application_no'),
                    field: 'applicationNo',
                },
                {
                    label: this.$t('trademarkOppositionBasisForOpposition.trademark'),
                    field: 'name',
                },
                {
                    label: this.$t('trademarkOppositionBasisForOpposition.trademark_nice_class'),
                    field: 'niceClass',
                },
            ],
            rows: [],
            searchTerm: '',
            pageLength: 10,
            pageNo: 1,
            total: 0,
            selected: null,
            trademarkName: '',
        }
    },
    mounted() {
        this.getTrademarkOppositionBasisForOppositionList()
    },
    methods: {
        getTrademarkOppositionBasisForOppositionList() {
            this.rows = []
            const data = {
                trademarkOppositionId: this.trademarkOppositionId,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                trademarkName: this.trademarkName
            };
            const controller = {
                name: 'Trademark',
                actionName: 'GetTrademarkListByTrademarkOppositionOwnerByTrademarkOppositionId',
            };
            const payload = {
                data: data,
                controller: controller,
            };
            this.$store.dispatch('moduleAuth/customService', payload).then(response => {
                if (response.data.resultStatus) {
                    response.data.trademarkListByTrademarkOppositionOwner.forEach(element => {
                        this.rows.push(element)
                    })
                    this.total = response.data.total
                } else if (
                    response.data.resultStatus === false &&
                    response.data.resultMessage === 'AddTrademarkOppositionOwnerFirst'
                ) {
                    this.$OppositionOwnerDoesntExistAlert();
                } else if (
                    response.data.resultStatus === false &&
                    response.data.resultMessage ===
                    'TrademarkOppositionBasisForOppositionOnlyAddedWhenStatusToBeFiled'
                ) {
                    this.$OppositionStatusNotToBeFilledAlert();
                } else {
                    this.$WarningAlert(response.data.resultMessage);
                }
            });
        },
        saveTrademarkOppositionBasis(checked, row) {
            const controller = {
                name: 'TrademarkOppositionBasisForOpposition',
            };
            if (checked === true) {
                const data = {
                    trademarkOppositionId: this.trademarkOppositionId,
                    trademarkId: row.id,
                    name: row.name,
                    applicationNo: row.applicationNo
                };
                const payload = {
                    data: data,
                    controller: controller,
                };
                this.$store.dispatch('moduleAuth/save', payload).then(response => {
                    if (response.data.resultStatus) {
                        this.getTrademarkOppositionBasisForOppositionList();
                        this.$SaveAlert();
                    } else {
                        this.$WarningAlert(response.data.resultMessage);
                    }
                });
            } else {
                const deleteData = {
                    trademarkId: row.Id,
                    trademarkOppositionId: this.trademarkOppositionId,
                };
                const deleteController = {
                    name: 'TrademarkOppositionBasisForOpposition',
                };
                const payload = {
                    data: deleteData,
                    controller: deleteController,
                };
                this.$DeleteConfirm().then(result => {
                    if (result.value) {
                        this.$store.dispatch('moduleAuth/delete', payload).then(response => {
                            if (response.data.resultStatus) {
                                this.getTrademarkOppositionBasisForOppositionList();
                                this.$DeleteAlert();
                            } else {
                                this.$WarningAlert(response.data.resultMessage);
                                this.getTrademarkOppositionBasisForOppositionList();
                            }
                        });
                    }
                });
            }
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
